// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__+R9Nz","Modal_Content":"Modal_Modal_Content__qpi4e"};